// extracted by mini-css-extract-plugin
module.exports = {"arl_rs_tit":"arl_rs_tit-2amBTk9g","arl_md_rank":"arl_md_rank-2ZnZaY-G","n":"n-3aAWxo19","img":"img-2bYosSAF","name":"name-2Nch5bV_","price":"price-3pE93h0j","nt":"nt-1cF7sGcT"};